import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_MULTI_BUNDLES = createFcmConfig('corgi_multi_bundles', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
